export default __webpack_public_path__ + "static/media/logout-blue.ef90192c.svg";